import { URLS, createJurisdictionHeaders } from '@/data';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { useMutation } from '@tanstack/react-query';

import { PRODUCT_TO_TERMS_VERTICALS, Verticals } from '../utils/terms-and-conditions-utils';

const userAcceptProductTerms = async (verticals: Verticals[]): Promise<boolean> => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/user/tnc`, {
        method: 'POST',
        headers: {
            ...createJurisdictionHeaders(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ verticals }),
    });

    const responseData = await response.json();

    if (!response.ok) {
        throw { message: responseData.message || 'Error accepting product terms and conditions', responseData };
    }

    return responseData.success;
};

export const useUserAcceptProductTerms = () => {
    const product = useJurisdictionStore(state => state.product);
    const activeProductTermsVerticals = PRODUCT_TO_TERMS_VERTICALS[product] || [];

    const verticals = activeProductTermsVerticals;

    return useMutation({
        mutationKey: ['user-accept-product-terms'],
        mutationFn: () => userAcceptProductTerms(verticals),
    });
};
